<template>
  <modal
    name="addcard-modal"
    :width="'100%'"
    height="auto"
    :adaptive="true"
    :max-width="450"
    @opened="opened"
    @closed="closed"
    @before-open="beforeOpen"
  >
    <div>
      <div class="modal-header">
        <button @click="$modal.hide('addcard-modal')" class="close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row d-flex">
          <div class="col-12">
            <div class="col-12"><h4 class="modal-title">Add a Card</h4></div>
            <form id="checkout-form" class="d-flex flex-column">
              <div class="col-12 mt-2" id="card-number-bootstrap">
                <label>Card Number</label>
                <div id="card-number" class="form-control"></div>
                <label
                  class="help-block mt-1"
                  for="card-number"
                  id="card-number-error"
                ></label>
              </div>
              <div class="d-flex col-12">
                <div class="col-6 pl-0 mt-2" id="card-expiry-bootstrap">
                  <label>Expiration Date</label>
                  <div id="card-expiry" class="form-control"></div>
                  <label
                    class="help-block mt-1"
                    for="card-expiry"
                    id="card-expiry-error"
                  ></label>
                </div>

                <div class="col-6 px-0 mt-2" id="card-cvv-bootstrap">
                  <label>CVV</label>
                  <div id="card-cvv" class="form-control"></div>
                  <label
                    class="help-block mt-1"
                    for="card-cvv"
                    id="card-cvv-error"
                  ></label>
                </div>
              </div>

              <div class="d-flex col-xs-6 text-center">
                <button
                  id="pay-button"
                  type="submit"
                  class="btn add-btn disabled"
                  disabled="true"
                >
                  Save Card
                </button>
              </div>

              <div class="modal-footer mt-3">
                <span class="inc-text">
                  We use Bambora Inc. to process all credit card payments.
                  Processing a payment or saving a payment method to your
                  profile does not provide hungerhub Canada Inc. with access to
                  nor allow for the retention of any credit card information.
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { addCardToProfile } from "../utils/api";
import { errorHandler } from "@/utils/errorHandler";
import { mapGetters } from "vuex";

var customCheckout = null;

var isCardNumberComplete = false;
var isCVVComplete = false;
var isExpiryComplete = false;

export default {
  name: "AddCardModal",
  data() {
    return {
      token: null
    };
  },
  computed: {
    ...mapGetters(["getFirstEmployeeId"])
  },
  methods: {
    beforeOpen(event) {},
    closed() {
      this.removeListeners();
      customCheckout = null;
      this.hasResult = false;
    },
    opened(event) {
      this.createInputs();
      this.addListeners();
    },
    createInputs: () => {
      customCheckout = customcheckout();
      let options = {};

      // Create and mount the inputs
      options.placeholder = "Card number";
      customCheckout?.create("card-number", options)?.mount("#card-number");

      options.placeholder = "CVV";
      customCheckout?.create("cvv", options)?.mount("#card-cvv");

      options.placeholder = "MM / YY";
      customCheckout?.create("expiry", options)?.mount("#card-expiry");
    },
    removeListeners() {
      document
        ?.getElementById("checkout-form")
        ?.removeEventListener("submit", this?.onSubmit);
    },
    addListeners() {
      // listen for submit button
      if (document?.getElementById("checkout-form") !== null) {
        document
          ?.getElementById("checkout-form")
          ?.addEventListener("submit", this?.onSubmit, true);
      }

      customCheckout.on("brand", event => {
        let cardLogo = "none";
        if (event.brand && event.brand !== "unknown") {
          let filePath =
            "https://cdn.na.bambora.com/downloads/images/cards/" +
            event.brand +
            ".svg";
          cardLogo = "url(" + filePath + ")";
        }
        document.getElementById("card-number").style.backgroundImage = cardLogo;
      });

      customCheckout.on("empty", event => {
        if (event.empty) {
          if (event.field === "card-number") {
            isCardNumberComplete = false;
          } else if (event.field === "cvv") {
            isCVVComplete = false;
          } else if (event.field === "expiry") {
            isExpiryComplete = false;
          }
          this?.setPayButton(false);
        }
      });

      customCheckout?.on("complete", event => {
        if (event.field === "card-number") {
          isCardNumberComplete = true;
          this?.hideErrorForId("card-number");
        } else if (event.field === "cvv") {
          isCVVComplete = true;
          this?.hideErrorForId("card-cvv");
        } else if (event.field === "expiry") {
          isExpiryComplete = true;
          this?.hideErrorForId("card-expiry");
        }

        this.setPayButton(
          isCardNumberComplete && isCVVComplete && isExpiryComplete
        );
      });

      customCheckout?.on("error", event => {
        if (event.field === "card-number") {
          isCardNumberComplete = false;
          this.showErrorForId("card-number", event.message);
        } else if (event.field === "cvv") {
          isCVVComplete = false;
          this.showErrorForId("card-cvv", event.message);
        } else if (event.field === "expiry") {
          isExpiryComplete = false;
          this.showErrorForId("card-expiry", event.message);
        }
        this.setPayButton(false);
      });
    },
    onSubmit(event) {
      let loader = this.$loading.show();

      event.preventDefault();
      this?.setPayButton(false);

      let callback = result => {
        loader.hide();

        if (result.error) {
          this?.processTokenError(result.error);
        } else {
          this?.processTokenSuccess(result.token);
        }
      };

      customCheckout.createToken(callback);
    },
    hideErrorForId(id) {
      let element = document?.getElementById(id);

      if (element !== null) {
        let errorElement = document?.getElementById(id + "-error");
        if (errorElement !== null) {
          errorElement.innerHTML = "";
        }

        let bootStrapParent = document?.getElementById(id + "-bootstrap");
        if (bootStrapParent !== null) {
          bootStrapParent.classList.remove("has-error");
          bootStrapParent.classList.add("has-success");
        }
      } else {
        console.log("showErrorForId: Could not find " + id);
      }
    },
    showErrorForId(id, message) {
      let element = document?.getElementById(id);

      if (element !== null) {
        let errorElement = document?.getElementById(id + "-error");
        if (errorElement !== null) {
          errorElement.innerHTML = message;
        }

        let bootStrapParent = document?.getElementById(id + "-bootstrap");
        if (bootStrapParent !== null) {
          bootStrapParent.classList.add("has-error");
          bootStrapParent.classList.remove("has-success");
        }
      } else {
        console.log("showErrorForId: Could not find " + id);
      }
    },
    setPayButton(enabled) {
      let payButton = document?.getElementById("pay-button");
      if (enabled) {
        payButton.disabled = false;
        payButton.className = "btn add-btn";
      } else {
        payButton.disabled = true;
        payButton.className = "btn add-btn disabled";
      }
    },
    addCardToProfile(token) {
      let loader = this.$loading.show();

      addCardToProfile({ token }, this.getFirstEmployeeId)
        .then(response => {
          loader.hide();
          if (response.data && response.data.processed) {
            this.$modal.hide("addcard-modal");
            this.$root.$emit("onGetCards");
          } else {
            if (response?.data?.message)
              this.$swal({
                title: response?.data?.message,
                confirmButtonText: "OK"
              });
          }
        })
        .catch(err => {
          loader.hide();
          this.$swal({
            title: "Sorry we are unable to process your request.",
            text:
              "Please start a live chat for further assistance or email us at help@hungerhub.com",
            confirmButtonText: "OK"
          });

          errorHandler(err);
        });
    },
    processTokenError(error) {
      error = JSON.stringify(error, undefined, 2);

      this?.setPayButton(true);
    },
    processTokenSuccess(token) {
      if (token !== this.token) {
        this.token = token;
        this?.addCardToProfile(this.token);
        this?.setPayButton(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#checkout-form {
  margin: 10px 0px;
}

.modal-title {
  font-size: 22px;
  color: #393838;
}

#checkout-form label {
  font-weight: 500;
  color: #212529 !important;
  font-size: 12px;
  margin-bottom: 7px;
}

/* card images are added to card number */
#card-number {
  background-image: none;
  background-origin: content-box;
  background-position: calc(100%) center;
  background-repeat: no-repeat;
  background-size: contain;
}

/* feedback is displayed after tokenization */
#feedback {
  position: relative;
  left: 15px;
  display: inline-block;
  background-color: transparent;
  border: 0px solid rgba(200, 200, 200, 1);
  border-radius: 4px;
  transition: all 100ms ease-out;
  padding: 11px;
}

#feedback.error {
  color: red;
  border: 1px solid;
}

#feedback.success {
  color: seagreen;
  border: 1px solid;
}

.modal-body {
  padding: 0 15px;
  text-align: left;
}

.cross-cancel-icon {
  width: 28px;
  height: 28px;
  margin-top: 26px;
  margin-left: 26px;
}

.add-btn {
  display: block;
  width: calc(100%);
  height: 40px;
  margin: 20px 15px 0;
  background-color: #6c6bcc;
  border-radius: 9px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  cursor: pointer;
}

.add-btn:hover {
  background-color: #373981;
}

.main-text {
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #ec008c;
}

.subtext {
  width: 100%;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.1px;
  text-align: left;
  color: #ec008c;
}

.modal-footer {
  border-top: none;
}

.modal-header {
  border-bottom: none;
  padding: 0;
  padding-right: 0.5rem;
}

.inc-text {
  color: #707070;
  font-size: 8px;
}

@media (max-width: 500px) {
  .cross-cancel-icon {
    width: 20px;
    height: 20px;
    margin-top: 20px;
    margin-left: 20px;
  }

  .main-text {
    font-size: 18px;
  }

  .subtext {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddCardModal.vue